import { useNavigate, createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '@/lib/auth-context'
import { useSetupStatus } from '@/hooks/use-setup-status'
import { isHardIncomplete } from '@/lib/setup-status'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Egg, LogOut, Clock } from 'lucide-react'

const MISSING_LABELS: Record<string, string> = {
  organization: 'organização',
  granja: 'granja',
  galpao: 'galpão',
  lote: 'lote',
  admin_user: 'administrador',
}

function AguardandoConfiguracaoPage() {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const { status, isReady } = useSetupStatus()

  useEffect(() => {
    if (!isReady) return
    if (status.blocking && status.can_setup) {
      void navigate({ to: '/setup', replace: true })
      return
    }
    if (!isHardIncomplete(status.missing)) {
      void navigate({ to: '/dashboard', replace: true })
    }
  }, [isReady, status, navigate])

  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-muted-foreground">Carregando...</p>
      </div>
    )
  }

  const pendentes = status.missing
    .filter((m) => MISSING_LABELS[m])
    .map((m) => MISSING_LABELS[m])

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 font-semibold">
          <Egg className="h-6 w-6 text-primary" />
          <span>GranjaSmart</span>
        </div>
        <Button variant="ghost" size="sm" onClick={() => void logout()}>
          <LogOut className="h-4 w-4 mr-2" />
          Sair
        </Button>
      </header>

      <main className="max-w-md mx-auto py-16 px-4">
        <Card>
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
              <Clock className="h-7 w-7 text-amber-600" />
            </div>
            <CardTitle>Aguardando configuração</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-muted-foreground text-sm">
              Sua granja ainda não está pronta para operação. Um administrador precisa
              concluir a configuração inicial.
            </p>
            {pendentes.length > 0 && (
              <p className="text-sm">
                Pendente: <strong>{pendentes.join(', ')}</strong>
              </p>
            )}
            <p className="text-xs text-muted-foreground">
              Entre em contato com o administrador da sua organização. Você será
              notificado quando a granja estiver operacional.
            </p>
          </CardContent>
        </Card>
      </main>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/aguardando-configuracao')({
  component: AguardandoConfiguracaoPage,
})
